<div class="header">
  <h1 class="header-title">
    <mat-icon *ngIf="icon.length > 0" class="header-icon">{{icon}}</mat-icon>
    {{data.title}}
  </h1>

  <lib-button (click)="dismiss('closeBtn')" icon="close" color="none" textColor="muted" tooltip="{{'form.close' | translate}}">
  </lib-button>
</div>

<mat-dialog-content *ngIf="data.content || confirmationWord">
  <p *ngIf="data.content">{{data.content}}</p>

  <mat-form-field *ngIf="confirmationWord" class="confirmation-field" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{confirmationLabel}}</mat-label>
    <input matInput cdkFocusInitial autocomplete="off" [ngModel]="confirmationInput()"
      (ngModelChange)="confirmationInput.set($event)" (keyup.enter)="ok()">
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="btn-actions">
  <lib-button [color]="cancelColor" (click)="dismiss('cancelBtn')" [text]="cancelText" [icon]="cancelIcon"></lib-button>
  <lib-button [color]="okColor" [disabled]="!confirmationValid()" (click)="ok()" [text]="okText" [icon]="okIcon"></lib-button>
</mat-dialog-actions>
